export const fetchPlayerSeasonStats = async (playerId) => {
  const year = new Date().getFullYear();
  const [seasonRes, lastGamesRes, splitRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/people/${playerId}/stats?stats=season&group=hitting,pitching&season=${year}`),
    fetch(`https://statsapi.mlb.com/api/v1/people/${playerId}/stats?stats=gameLog&group=hitting,pitching&season=${year}&limit=10`),
    fetch(`https://statsapi.mlb.com/api/v1/people/${playerId}/stats?stats=statSplits&group=hitting,pitching&season=${year}&sitCodes=h,a,vl,vr`),
  ]);
  const season = seasonRes.ok ? await seasonRes.json() : null;
  const lastGames = lastGamesRes.ok ? await lastGamesRes.json() : null;
  const splits = splitRes.ok ? await splitRes.json() : null;
  return { season, lastGames, splits };
};